import Module from 'epa-components-platform/src/lib/helper/js/Module';
import helperDOM from 'epa-components-platform/src/lib/helper/js/helperDOM';

export default class SiteWrapper extends Module  {
  constructor(el) {
    super();

    this.el = el;
    this.on('mobileMenuToggle', this.onMobileMenuToggle );
  }

  onMobileMenuToggle = () => {
    helperDOM.toggleClass(this.el, 'is-mobile-menu-opened');
  }
}